export const CREATE_INQUIRY = '/createinquiry'
export const DUEOUT = '/createdueout'
export const DUEOUTS = '/dueouts'
export const INQUIRIES = '/inquiries'
export const MY_INQUIRIES = '/myinquiries-dueouts'
export const ROUTE_TYPE = '/'
export const PROFILE = '/profile'
export const RHYBUS_ACCESS_TOKEN = 'rhybustoken'
export const APP_NAME = 'DSCA'
export const CLIENT_CODE = 'clientcode'
export const SessionTimeOut = 20 * 60 * 1000

export const VISIBLE_ROWS = 30 // visible rows for infinite scroll
export const VIEW_LIMIT_THRESHOLD = 5000
export const GENERAL_USER_GROUP = 'All Users'
export const VALIDATE_PII_CONTENT = true
export const VALIDATE_PII_CONTENT_DISCUSSIONS = true
export const VALIDATE_PII_CONTENT_FILES = true
export const COMMENT_TO_IN_DISCUSSIONS = true
export const FullControlUserGroups = ['ReactTemplate Owners', 'ReactTemplate1Int Owners']
export const APP_CONFIG_GROUP = 'AppAdmin'
export const UPDATE_BUILD_VERSION = 'Are you sure, you want to update the Build version?'
export const DELETE_MSG = 'Are you sure, you want to delete the selected item?'
export const CLOSE_MSG = 'Are you sure you want to close the page?'
export const CALENDAR_EVENT_MSG = 'Are you sure, you want to delete this calendar event?'
export const NO_CHANGE_MSG = 'No changes detected'
export const FILTER_CHANGE_UNSAVED_MSG = 'You have unsaved changes. Changing filters will clear your unsaved data. Do you want to proceed?'
export const CALENDAR_TOGGLE_UNSAVED_MSG = 'You have unsaved changes. Switching to Calendar view will clear your unsaved data. Do you want to proceed?'
export const SELECT_ITEM = 'Select a item to continue'
export const SELECT_ONE_ITEM = 'Please select at least one document to delete.'
export const SELECT_TEAM_MEBR = 'Please select at least one team member to delete.'
export const DELETE_TEAM_MEBR = 'Are you sure you want to delete the selected team member(s)?'
export const VERSION_NAME = 'Same version name already exists.'
export const DELETE_USER = 'Are you sure, you want to delete the user?'
export const VALIDATION_MSG = 'You do not have permissions to delete users from this group'
export const VALID_USER_MSG = 'Please search valid user name (or) email'
export const VALID_LENGTH_MSG = 'Please check atleast a role that need to be added.'
export const MAX_NUM_FILES = 10
export const MAX_FILE_SIZE = 26214400 // 25 MB
export const ACCEPTABLE_FILE_TYPES = [
    'xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx',
    'txt', 'pdf', 'png', 'jpg', 'jpeg', 'gif', 'msg'
]
export const NA_VALUE = 'N/A'
export const ALL_SELECT_LABEL = 'All'
export const NONE_LABEL = 'None'
export const SELECT_LABEL = 'Select'
export const NONE_SELECT_OPTION = {
    label: NONE_LABEL,
    value: NONE_LABEL,
}
export const SELECT_OPTION = {
    label: SELECT_LABEL,
    value: SELECT_LABEL,
}
export const ALL_OPTION = {
    label: ALL_SELECT_LABEL,
    value: ALL_SELECT_LABEL,
}
export const FILE_CHARACTERS_UNALLOWED = [',', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '+', '=', '[', ']', '{', '}', 'ʻ', ':', '“', '|', '<', '>', '/', '?', '~']
export const OVERRIDE_METADATA = 'Are you sure, you want to override all Metadata?'
export const COMPLETED_MESSAGE = 'Completed'
export const FILE_HINT_MSG = 'Upload the files which are in the .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf, .png, .jpg, .jpeg, .gif, .msg and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.'
export const CSV_FILE_HINT_MSG = 'Upload the file which are in the .xlsx .csv and special characters will not be used in the document names. Maximum size for file is 25 MB.'
export const xls_FILE_HINT_MSG = 'Upload the file which are in the .xlsx and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 1 file per screen.'
// Error/Confirmation display messages
export const SELECT_MESSAGE = 'Please select'
export const ENTER_MSG = 'Please enter'
export const SELECT_DATE = 'Please select date'
export const ENTER_MAIL_ID = 'Please eneter valid mail ID'
export const NORESULT = 'There are no results to display'
export const FILENAME_REGEX = /['~#%{}+]|\\.\\.|^\\.|\\.$/
export const UPDATE_ALERT = 'No Changes Detected'

//Success Messages
export enum SuccessMsg {
    ANNOUNCEMENT_SUBMIT_SUCCESS_MSG = 'Announcement added Successfully',
    ANNOUNCEMENT_UPDATE_SUCCESS_MSG = 'Announcement updated Successfully',
    ANNOUNCEMENT_DELETE_SUCCESS_MSG = 'Announcement deleted Successfully',
    KNOWLEDGEGRAPH_SUBMIT_SUCCESS_MSG = 'Knowledge Base added Successfully',
    KNOWLEDGEGRAPH_UPDATE_SUCCESS_MSG = 'Knowledge Base updated Successfully',
    KNOWLEDGEGRAPH_DELETE_SUCCESS_MSG = 'Knowledge Base deleted Successfully',
    QA_SUBMIT_SUCCESS_MSG = 'Q&A added Successfully',
    QA_UPDATE_SUCCESS_MSG = 'Q&A updated Successfully',
    QA_DELETE_SUCCESS_MSG = 'Q&A deleted Successfully',
    Quicklinks_SUBMIT_SUCCESS_MSG = 'Submitted Quicklinks are listed in alphabetical order by name',
    Quicklinks_UPDATE_SUCCESS_MSG = 'Updated Quicklinks are listed in alphabetical order by name',
    Quicklinks_DELETE_SUCCESS_MSG = 'Quicklinks deleted Successfully',
    POC_SUBMIT_SUCCESS_MSG = 'Submitted POCs are listed in alphabetical order by name',
    POC_UPDATE_SUCCESS_MSG = 'Updated POCs are listed in alphabetical order by name',
    POC_DELETE_SUCCESS_MSG = 'Points Of Contact deleted Successfully',
    PMG_FOLDER_SUBMIT_SUCCESS_MSG = 'Created Folders are listed in alphabetical order',
    PMG_FOLDER_UPDATE_SUCCESS_MSG = 'Updated Folders are listed in alphabetical order',
    PMG_FOLDER_DELETE_SUCCESS_MSG = 'Folder deleted Successfully',
    PMG_FILE_SUBMIT_SUCCESS_MSG = 'Submitted Files are listed in alphabetical order',
    PMG_FILE_UPDATE_SUCCESS_MSG = 'Updated Files are listed in alphabetical order',
    PMG_FILE_DELETE_SUCCESS_MSG = 'File deleted Successfully',
}

// Submission Type Info
export const Submission = {
    SAVE: 'Save',
    SUBMIT: 'Submit',
    UPDATE: 'Update',
    FOLDER_SUBMIT: 'FolderSubmit',
    FOLDER_UPDATE: 'FolderUpdate',
    FOLDER_DELETE: 'FolderDelete',
    FILE_SUBMIT: 'FileSubmit',
    FILE_UPDATE: 'FileUpdate',
    FILE_DELETE: 'FileDelete'
}

/// / Backend call status
export enum FetchStatus {
    SUCCESS = 'Success',
    LOADING = 'Loading',
    FAILED = 'Failed'
}

/// / Display types
export const Display = {
    PAGE: 'Page',
    TILE: 'Tile'
}

export const Filter_Options = [
    { key: 'year', label: 'Year', sortOrder: 'year', canSort: true, options: ['2024', '2025', '2026'] },
    { key: 'hospital', label: 'Hospital', sortOrder: 'hospital', canSort: true, options: ['Hospital A', 'Hospital B', 'Hospital C'] },
    { key: 'department', label: 'Department', sortOrder: 'department', canSort: true, options: ['Department 1', 'Department 2', 'Department 3'] },
    { key: 'severity', label: 'Severity', sortOrder: 'severity', canSort: true, options: ['Low', 'Medium', 'High'] },
]

export const IMPORTDATA_TABLE_COLUMNS = [
    { key: 'Unit', label: 'Unit', sortOrder: 'Unit', canSort: true },
    { key: 'Occupancy', label: 'Occupancy', sortOrder: 'Occupancy', canSort: true },
    { key: 'AvailableBeds', label: 'Available Beds', sortOrder: 'AvailableBeds', canSort: true },
    { key: 'EDBoarders', label: 'ED Boarders', sortOrder: 'EDBoarders', canSort: true },
    { key: 'DischargeReady', label: 'Discharge Ready', sortOrder: 'DischargeReady', canSort: true },
    { key: 'EVSTurnaroundMin', label: 'EVS Turnaround Min', sortOrder: 'EVSTurnaroundMin', canSort: true },
    { key: 'TransportResponseMin', label: 'Transport Response Min', sortOrder: 'TransportResponseMin', canSort: true },
    { key: 'OrdersPending', label: 'Orders Pending', sortOrder: 'OrdersPending', canSort: true },
    { key: 'AvgFillTimeMin', label: 'Avg Fill Time Min', sortOrder: 'AvgFillTimeMin', canSort: true }
]

export const List_Filter_Options = [
    { key: 'year', label: 'Year', sortOrder: 'year', canSort: true, options: ['2024', '2025', '2026'] },
    { key: 'hospital', label: 'Hospital', sortOrder: 'hospital', canSort: true, options: ['Hospital A', 'Hospital B', 'Hospital C'] },
    { key: 'department', label: 'Department', sortOrder: 'department', canSort: true, options: ['Department 1', 'Department 2', 'Department 3'] },
    { key: 'severity', label: 'Severity', sortOrder: 'severity', canSort: true, options: ['Low', 'Medium', 'High'] },
    { key: 'duedate', label: 'Due Date', sortOrder: 'duedate', canSort: true, options: [''] },
    { key: 'submitteddate', label: 'Submitted Date', sortOrder: 'submitteddate', canSort: true, options: [''] },
]

export const ACTION_QUEUES_TABLE_COLUMNS = [
    { key: 'id', label: 'ID', sortOrder: 'id', canSort: true },
    { key: 'department', label: 'Department', sortOrder: 'department', canSort: true },
    { key: 'impact', label: 'Impact', sortOrder: 'impact', canSort: true },
    { key: 'severity', label: 'Severity', sortOrder: 'severity', canSort: true },
    { key: 'createdby', label: 'Created by', sortOrder: 'createdby', canSort: true },
    { key: 'createddatetime', label: 'Created Date/Time', sortOrder: 'createddatetime', canSort: true },
    { key: 'duedatetime', label: 'Due Date/Time', sortOrder: 'duedatetime', canSort: true },
    { key: 'status', label: 'Status', sortOrder: 'status', canSort: true }
]

export const ACTIVE_ACTION_QUEUES_TABLE_COLUMNS = [
    { key: 'issue', label: 'Issue', sortOrder: 'issue', canSort: true },
    { key: 'impact', label: 'Impact', sortOrder: 'impact', canSort: true },
    { key: 'department', label: 'Department', sortOrder: 'department', canSort: true },
    { key: 'owner', label: 'Owner', sortOrder: 'owner', canSort: true },
    { key: 'due', label: 'Due', sortOrder: 'due', canSort: true },
    { key: 'slaremaining', label: 'SLA Remaining', sortOrder: 'slaremaining', canSort: true },
    { key: 'status', label: 'Status', sortOrder: 'status', canSort: true }
]

export const THROUGHPUT_DELAYS_TABLE_COLUMNS = [
    { key: 'patientid', label: 'Patient ID', sortOrder: 'patientid', canSort: true },
    { key: 'delayreason', label: 'Delay Reason', sortOrder: 'delayreason', canSort: true },
    { key: 'unit', label: 'Unit/Bed', sortOrder: 'unit', canSort: true },
    { key: 'timelost', label: 'Time Lost', sortOrder: 'timelost', canSort: true },
    { key: 'actions', label: 'Actions', sortOrder: 'actions', canSort: true },
]

export const OPERATION_IMPACT_TABLE_COLUMNS = [
    { key: 'supportservice', label: 'Support Service', sortOrder: 'supportservice', canSort: true },
    { key: 'impacteddept', label: 'Impacted Dept', sortOrder: 'impacteddept', canSort: true },
    { key: 'affectedmetric', label: 'Affected Metric', sortOrder: 'affectedmetric', canSort: true },
    { key: 'currentdelay', label: 'Current Delay', sortOrder: 'currentdelay', canSort: true },
    { key: 'linkedaction', label: 'Linked Action', sortOrder: 'linkedaction', canSort: true },
    { key: 'status', label: 'Status', sortOrder: 'status', canSort: true },

]

export const sampleData = [
    {
        issue: 'Pharmacy turnaround time breach',
        impact: 'Patient Safety',
        department: 'Operating Room',
        owner: 'Sarah Connor',
        due: '15:00',
        slaremaining: '01:15',
        status: 'In Progress',
        ItemGUID: '000023'
    }, {
        issue: 'Pharmacy turnaround time breach',
        impact: 'Patient Safety',
        department: 'Operating Room',
        owner: 'Sarah Connor',
        due: '15:00',
        slaremaining: '01:15',
        status: 'In Progress',
        ItemGUID: '000023'
    }, {
        issue: 'Pharmacy turnaround time breach',
        impact: 'Patient Safety',
        department: 'Operating Room',
        owner: 'Sarah Connor',
        due: '15:00',
        slaremaining: '01:15',
        status: 'In Progress',
        ItemGUID: '000023'
    }, {
        issue: 'Pharmacy turnaround time breach',
        impact: 'Patient Safety',
        department: 'Operating Room',
        owner: 'Sarah Connor',
        due: '15:00',
        slaremaining: '01:15',
        status: 'In Progress',
        ItemGUID: '000023'
    }, {
        issue: 'Pharmacy turnaround time breach',
        impact: 'Patient Safety',
        department: 'Operating Room',
        owner: 'Sarah Connor',
        due: '15:00',
        slaremaining: '01:15',
        status: 'In Progress',
        ItemGUID: '000023'
    }
]

export const throughputDelaysData = [
    {
        patientid: 'IP-9021',
        delayreason: 'Meds Delivery',
        unit: 'Paediatrics',
        timelost: '85 min',
        actions: '+ Create Action'
    },
    {
        patientid: 'IP-9021',
        delayreason: 'Meds Delivery',
        unit: 'Paediatrics',
        timelost: '85 min',
        actions: '+ Create Action'
    },
    {
        patientid: 'IP-9021',
        delayreason: 'Meds Delivery',
        unit: 'Paediatrics',
        timelost: '85 min',
        actions: '+ Create Action'
    },
]

export const operationImpactData = [
    {
        supportservice: 'EVS',
        impacteddept: 'OR',
        affectedmetric: 'Room Turnover Delay',
        currentdelay: '+12 min',
        linkedaction: '#00213',
        status: 'In Progress',
    },
    {
        supportservice: 'EVS',
        impacteddept: 'OR',
        affectedmetric: 'Room Turnover Delay',
        currentdelay: '+12 min',
        linkedaction: '#00213',
        status: 'In Progress',
    },
    {
        supportservice: 'EVS',
        impacteddept: 'OR',
        affectedmetric: 'Room Turnover Delay',
        currentdelay: '+12 min',
        linkedaction: '#00213',
        status: 'In Progress',
    },
    {
        supportservice: 'EVS',
        impacteddept: 'OR',
        affectedmetric: 'Room Turnover Delay',
        currentdelay: '+12 min',
        linkedaction: '#00213',
        status: 'In Progress',
    },
    {
        supportservice: 'EVS',
        impacteddept: 'OR',
        affectedmetric: 'Room Turnover Delay',
        currentdelay: '+12 min',
        linkedaction: '#00213',
        status: 'In Progress',
    }
]